import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
export default {
  update(el, binding, vNode) {
    var _context;
    const event = new Event("input", {
      bubbles: true
    });
    const valuesToSum = JSON.parse(binding.value);
    const sum = _reduceInstanceProperty(valuesToSum).call(valuesToSum, (acc, curr) => {
      return _parseInt(acc) + (_parseInt(vNode.context.vfjsModel[curr]) || 0);
    }, 0);
    const inputEl = _findInstanceProperty(_context = $(el)).call(_context, "input");
    if (sum && el.value != sum) {
      inputEl.val(sum);
      inputEl[0].dispatchEvent(event);
    }
  }
};